import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70953cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "commissions-section" }
const _hoisted_2 = {
  key: 0,
  class: "statement-status-section"
}
const _hoisted_3 = {
  key: 1,
  class: "statement-status-section"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Period")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "right-side" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Amount")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "statement-header" }
const _hoisted_8 = { class: "right-side js-month-balance" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Payed: ", -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "error"
}
const _hoisted_14 = {
  key: 3,
  class: "error"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "section-end-hr" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CollapsibleSection = _resolveComponent("CollapsibleSection")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.hasStatementsError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " There was an error retrieving commission statements "))
      : _createCommentVNode("", true),
    (_ctx.isStatementsLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading... "))
      : _createCommentVNode("", true),
    (_ctx.isStatementsLoaded && !_ctx.hasStatementsError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statementsByMonth, (statementMonth) => {
            return (_openBlock(), _createElementBlock("div", {
              key: statementMonth.month
            }, [
              _createVNode(_component_CollapsibleSection, {
                hideBorder: true,
                collapsed: _ctx.isStatementsCollapsed(statementMonth.month),
                onToggleCollapse: ($event: any) => (_ctx.toggleStatementsCollapsed(statementMonth.month))
              }, {
                caption: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(statementMonth.month), 1),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatDollars(statementMonth.total)), 1)
                  ])
                ]),
                content: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statementMonth.statements, (statement, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "statement-contents",
                      key: _ctx.generateItemId(index)
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, [
                          _createElementVNode("b", null, _toDisplayString(statement.commissionType), 1)
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass({ 'negative-line-item': _ctx.getStatementAmount(statement) < 0, 'right-side': true})
                        }, [
                          _hoisted_9,
                          _createTextVNode(_toDisplayString(_ctx.formatDollars(_ctx.getStatementAmount(statement))), 1)
                        ], 2)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.downloadStatementFile(statementMonth.month, statement)), ["prevent"]),
                          class: "js-download-statement"
                        }, " (Download) ", 8, _hoisted_10),
                        (statement.commissionType === 'Attune' && _ctx.downloadingAttuneStatement[statementMonth.month])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "⌛"))
                          : _createCommentVNode("", true),
                        (statement.commissionType === 'Partner' && _ctx.downloadingPartnerStatement[statementMonth.month])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "⌛"))
                          : _createCommentVNode("", true),
                        (statement.commissionType === 'Attune' && _ctx.errorDownloadingAttuneStatement[statementMonth.month])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Download failed"))
                          : _createCommentVNode("", true),
                        (statement.commissionType === 'Partner' && _ctx.errorDownloadingPartnerStatement[statementMonth.month])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Download failed"))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["collapsed", "onToggleCollapse"]),
              _hoisted_15
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hasStatementsError && !_ctx.isStatementsLoading)
      ? (_openBlock(), _createElementBlock("a", {
          key: 3,
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.loadMore()), ["prevent"])),
          class: "load-more-link"
        }, " Load More "))
      : _createCommentVNode("", true)
  ]))
}